import "./cumpleañosmes.css";
import React, { useState, useEffect, useRef } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import CargandoSpinner from "../0. Utilidades/loadingSpinner";
import PersonAvatar from "../0. Utilidades/PersonAvatar";
import { getApiUrl } from "../../utils/apiUrl";

function CumpleIcon() {
  const [cumpleMeses, setCumpleMeses] = useState([]); // Stores all months
  const [selectedMonth, setSelectedMonth] = useState(""); // Default: no month selected
  const [loading, setLoading] = useState(true); // Loading state for initial fetch
  const [showTooltip, setShowTooltip] = useState(null);
  const timerRef = useRef(null);

  // Fetch data on component mount
  useEffect(() => {
    const apiUrl = getApiUrl("api/personas/cumpleanos-meses/");

    fetch(apiUrl, { credentials: "include" })
      .then((response) => response.json())
      .then((data) => {
        setCumpleMeses(data); // Store full dataset
        setLoading(false); // Stop loading
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setLoading(false);
      });
  }, []);

  const handleMouseEnter = (index) => {
    clearTimeout(timerRef.current);
    setShowTooltip(index);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setShowTooltip(null);
    }, 500);
  };

  const handleTooltipMouseEnter = () => {
    clearTimeout(timerRef.current);
  };

  const handleTooltipMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setShowTooltip(null);
    }, 500);
  };

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  // Find the selected month data
  const selectedMonthData =
    cumpleMeses.find((mes) => mes.month === selectedMonth) || null;

  return (
    <div id="cumpleaños-meses">
      <h3>Mes Específico</h3>
      {/* Month Selector */}
      <select
        className="month-selector"
        onChange={handleMonthChange}
        value={selectedMonth}
      >
        <option value="">Selecciona un mes</option>
        {cumpleMeses.map((mes, index) => (
          <option key={index} value={mes.month}>
            {mes.month}
          </option>
        ))}
      </select>

      {/* Loading Spinner on Initial Fetch */}
      {loading && <CargandoSpinner />}

      {/* Show data only when a month is selected */}
      {selectedMonth && selectedMonthData && (
        <div id="cumpleaños-mes">
          <h3 className="cumpleaños-mes-header">
            Cumpleaños {selectedMonthData.month}
          </h3>
          <div className="cumpleaños-mes">
            {selectedMonthData.cumples.map((icon, index) => (
              <div className="cumpleaños-mes-icons" key={index}>
                <OverlayTrigger
                  placement="top"
                  show={showTooltip === index}
                  overlay={
                    <Tooltip
                      id={`tooltip-${selectedMonth}-${index}`}
                      className="custom-tooltip"
                      onMouseEnter={handleTooltipMouseEnter}
                      onMouseLeave={handleTooltipMouseLeave}
                    >
                      <strong>{icon.nombre}</strong>
                      <br />
                      {icon.nacimiento_formatted}
                      <br />
                      <a href={`/maestras/${icon.id}`}>Ver perfil</a>
                    </Tooltip>
                  }
                >
                  <div
                    className={`cumpleaños-mes-icon ${icon.color ? `${icon.color}-glow` : ""}`}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <PersonAvatar
                      src={icon.imagen}
                      name={icon.nombre}
                      alt={`Fotografía de ${icon.nombre}`}
                      className="birthday-person-avatar"
                      tone="maestra"
                    />
                  </div>
                </OverlayTrigger>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default CumpleIcon;
